<template>
  <div class="themeBody" :data-theme="themeMode">
  <go-back-button :is-align-center="true" v-if="$store.state.isInSlicer == true"
                    class="policiesGoBackButton">
      <template v-slot:body>
        用户协议
      </template>
    </go-back-button>

    <div style="text-align: left" v-html="articleContent"></div>
  </div>
</template>

<script>
import {articleDetail} from "@/api/api";

export default {
  data() {
    return {
      // articleContent: "",//接口获取的文章html代码
      articleTitle: `<h1>用户协议</h1>`,
      articleContent: "",
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  created() {
    // 后期更新了服务器上的接口html 再使用请求获取
    // this.getPrivacy()
    if (this.$store.state.isInSlicer == true) {
      this.articleTitle = ``
    }
    this.articleContent = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>用户协议</title>
</head>

<style data-emotion="portal-css-global hcq6pi">
    html {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        box-sizing: border-box;
        -webkit-text-size-adjust: 100%;
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    strong{
        font-size: 22px;
        font-weight: 700;
    }

    b {
        font-weight: 700;
    }

    body {
        margin: 0;
        color: #212B36;
        line-height: 1.5;
        font-size: 1.6rem;
        font-family: "Open Sans", "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans;
        font-weight: 400;
        background-color: #ffffff;
    }

    @media print {
        body {
            background-color: #fff;
        }
    }

    body::backdrop {
        background-color: #EEEEEE;
    }

    body {
        font-size: 16px;
    }
</style>

<style>
        .article-css {
            max-width: 800px;
            margin: 0 auto;
            padding: 0 20px;
            overflow: hidden;

        }

        .article-css a {
            color: #2196f4;
        }

        .article-css p {
            padding-bottom: 15px;
            color: #757575;
            line-height: 1.5;
        }

        .article-css h1 {
            font-size: 22px;
        }

</style>

<body>
    <div class="">
        <div class="article-css">
        ` +
        this.articleTitle +
        `
            <p>重要提示：本应用程序用户协议（以下简称“协议”）是您（以下简称为“用户”或“您”）与我们就使用我们的应用程序（以下称为“本产品”）达成的协议。在使用我们的应用程序之前，请仔细阅读本协议。
            </p>
            <h1><strong>一、服务说明</strong></h1>
            <p>本产品是一款移动应用程序，可连接到您的3D打印机，并允许您通过该应用程序远程控制3D打印机。</p>
            <p>1.起迪设备以及其中包含的软件，其中，软件包括但不限于存储在起迪设备上的代码和其他嵌入式软件、文档、界面、内容、字体以及任何受起迪或其许可方版权保护的数据；</p>
            <p>2.对本条第1款中所述的产品进行的更新或升级。</p>
            <p>（二） 除非另有其他约定，本条款中所包含的软件应受本条款约束，不论其是存储于只读存储器、任何其他介质或属于其他形式，还是来自起迪授权的在线下载位置均是如此。</p>
            <h1><strong>二、最终用户软件许可</strong></h1>
            <p>在遵守本条款的情况下，您有权在一台起迪设备或电脑上以有限的、非独家的方式使用软件（如第一条第（一）款第1项所定义），不得出售、转让或用于其他任何商业用途。</p>
            <h1><strong>三、您的义务</strong></h1>
            <p>通过使用本产品并同意这些条款，您保证：</p>
            <p>（一）未经起迪事先许可，不得使用起迪的技术或知识产权来开发软件，或者设计、开发、制造、销售与起迪产品<s>设备</s>相关联的第三方设备/附件，或授予许可。</p>
            <p>（二） 您可以制作一份软件副本并保存在计算机硬盘或其他存储介质上，以用于存档用途。但不得通过网络分发或提供本软件，以致其在同一时间可供多台设备或多台计算机使用。</p>
            <p>（三）未经起迪事先书面许可，不得向第三方出售、出租、租赁、出借、再许可或分发全部或部分软件。不过，您可以在转让起迪设备的同时将软件的整个许可证一次性地永久转让给另一方，条件是：
            </p>
            <p>1. 转让内容必须包括您的产品起迪设备和其中包含的所有软件；以及</p>
            <p>2. 不得保留全部或部分软件备份；以及</p>
            <p>3. 接收起迪产品的一方已阅读并同意接受本条款。</p>
            <p>（四）
                除非另有明示许可，您不得且不会允许其他任何人对本产品进行任何滥用、入侵或其他不当使用本产品的行为，包括对本产品以任何方式进行修改、解码、复制、拆装、发表、公开传播、反向工程、反编译、导出代码、反汇编或创作软件的衍生作品等行为。
            </p>
            <p>（五） 此外，您同意不使用本产品及相关更新内容从事以下行为：</p>
            <p>1. 在本条款授权范围之外复制或使用本产品的任何一部分内容；</p>
            <p>2. 在没有起迪书面允许的前提下，提供给第三方、或者允许第三方使用本软件的全部或者部分（包括但不局限于本服务下运营的应用、服务、代码和源代码等）；</p>
            <p>3. 以欺骗的方式或者为欺骗性目的使用本产品；</p>
            <p>4. 删除本产品内包含的任何一个版权声明和提示；</p>
            <p>5. 企图破坏、绕过、改变、作废或者逃避和本产品相关的以及/或者属于本产品有机组成的一部分的任何数字版权管理系统；</p>
            <p>6. 其他不当或违反法律的行为。</p>
            <p>（六）
                在使用本产品进行存储或复制时，您需要取得特定国家或地区的相关权利人的授权。起迪产品提供的材料复制功能仅限于复制没有版权保护的材料、您享有版权的材料或者您获得授权或合法许可进行复制的材料。您了解，通过您的设备显示、存储或访问的任何材料，其所有权和知识产权均属于该材料所有权人。此等材料可能受著作权法或其他知识产权法律和条约的保护，并可能需要遵守提供该等材料的第三方使用协议或条款。除非另有约定，本条款并未授予您使用该等材料的任何权利，亦不保证您可继续使用该等材料。
            </p>
            <p>（七）如果您选择提供与本产品有关的建议（“反馈”），则您谨此向起迪授予一项不受限制的、永久性的、不可撤销的、非排他性的、已经完全支付费用的、无特许费、无需另行通知的权利，以便起迪能够以任何方式并为了任何目的利用该等反馈，包括改进本产品和创造其他产品和服务。
            </p>
            <p>（八） 您同意在使用产品时遵守产品驻留或使用的国家或地区的所有适用法律和法规，包括但不限于您所居住或者下载或使用本产品以及服务的国家或地区的当地法律。</p>
            <h1><strong>四、权利保留</strong></h1>
            <p>起迪及其许可方享有和保留对产品的可视界面、图形、设计、固件、软件、服务以及其他所有元素的知识产权及其他权利和资格，并保留本条款未明确授予您的其他任何权利。</p>
            <h1><strong>五、用户协议</strong></h1>
            <p>起迪用户协议（以下简称“用户协议”）提供了与起迪收集的数据以及起迪使用这些数据的方式相关的信息。当您使用本产品时，起迪将依据本条款和用户协议的规定从您的设备上收集数据。您可在以下网站上查阅用户协议的详细信息：<a
                    href="#/policies/privacy">https://www.qidi3d.cn/policies/privacy</a>。
            </p>
            <h1><strong>六、使用数据</strong></h1>
            <p>（一）
                如果您选择帮助起迪提升其产品和服务，则起迪及其附属公司/许可方可从您的设备收集数据进行分析。收集的数据包括您的设备配置数据、应用程序统计数据和错误日志数据。所有数据在收集和处理前都会经过匿名化处理。
            </p>
            <p>（二）
                起迪确保按所有适用法律和法规的要求为您的数据提供近似且足够水平的保护。当您使用设备时，从您的产品<s>设备</s>中收集的数据可能被处理或传输到起迪及其位于您所居住的国家/地区以外的其他国家/地区的附属公司/许可方。这就意味着，这些数据可能传输到除您使用起迪产品或服务的国家/地区以外的其他司法管辖区或从这些司法管辖区进行访问。这些司法管辖区可能采用不同的数据保护法律，或者可能不存在此类法律。
            </p>
            <p>（三）
                起迪仅在满足本条款和用户协议中规定目的所需的时间期限内保留您的数据，除非法律要求或允许更长的保留期限。起迪将采取所有适当的技术和组织步骤以阻止对您数据的未经授权访问或披露，但仍需注意，任何安全措施都不是完全可靠的。
            </p>
            <h1><strong>七、产品更新</strong></h1>
            <p>（一）
                为了向您提供更好的用户体验，起迪可能会向您提供产品更新服务，包括但不限于系统软件更新、3D打印模型更新等。本产品的更新服务旨在提高产品和设备的性能、安全性和可靠性。产品的更新可以采用不同的安装方式，软件更新内容包括错误修复、系统软件更新、3D打印模型更新和性能增强等。
            </p>
            <p>（二）
                起迪致力于通过不时发布包含错误修复、新功能和安全更新的软件更新，确保我们的产品具有较长的使用寿命。我们承诺提供有保障的五年的软件更新(自产品发布开始)，更新内容包括令人兴奋的新功能和关键的错误修复等，以增强用户体验。&nbsp;<br>在前述的五年时间内，我们会例行经常的提供软件更新来增加新的功能，以进一步提升用户体验，同时也修复任何当时可能存在的错误。在此期间过后，只要有打印机能够支持的适合集成的功能，我们仍然会视情况继续带来包含更多改进提升的升级更新。&nbsp;<br>同时，鉴于数字威胁的不断发展和安全的重要性，起迪还承诺提供不少于七年的软件安全更新；如果我们发现新的安全问题并需要修补，则我们仍将在整个产品生命周期内持续提供安全漏洞更新。
            </p>
            <p>（三）
                起迪提供的替换或补充性产品更新均受本条款约束，除非此类更新随附单独的用户协议，此情况下将受后者约束。如果您决定不下载起迪提供的更新，您理解并认可，您可能将产品置于严重的安全风险，并可能导致产品不可用或不稳定。部分产品功能可能受软件版本限制，因而更新到软件最新版本可提升您的用户体验。
            </p>
            <p>（四）
                您的起迪产品会自动搜索并下载新的更新包，为您提供及时的更新服务。这些更新旨在解决网络安全漏洞，防止新的威胁，故及时接受和安装安全相关的系统更新非常重要。由于这些更新的重要性，您的产品可能会在安装更新之前阻止新的打印作业，并会立即提供更新通知以帮助您了解相关信息。
            </p>
            <h1><strong>八、本产品服务</strong></h1>
            <p>（一） 本产品可以使您访问本产品附带的相关起迪和第三方应用与服务
                （统称及个别称为“服务”）。但由于部分服务存在区域属性，因此这些服务未必能以各种语言或在各个区域提供，某些功能可能因地区而异，有的可能会受到限制，或您的服务提供商没有提供。此外，您理解并同意，本产品的某些功能的可能还会受到<s>设备</s>硬件及数据访问的影响或限制，并不一定在所有产品上提供。
            </p>
            <p>（二）
                为保证并提升您的用户体验，本产品为您准备了系统服务。本产品下各服务的具体内容由起迪及其附属公司/许可方根据实际情况提供。起迪及其附属公司/许可方可以对其提供的服务予以变更，且提供的服务内容可能随时变更。
            </p>
            <p>1.<strong>QiDi云</strong>，QiDi云是为您提供使用起迪云服务的基础功能。这些基础功能包括起迪账号管理功能、无线发送打印、远程监控、模型推荐。以上功能未必在所有地区/国家和以各种语言提供。使用这些基础功能需要接入互联网，并且需要您注册起迪账号和接受以上基础服务的附加条款。
            </p>
            <p>2.<strong>模型推荐</strong>，模型推荐是为您推荐存储在QiDi云上模型的服务。在您连接Wi-Fi网络时会向您推荐模型内容，模型内容会因您登录账号所在国家/地区的不同而有所差异。您可以选择接受或拒绝本服务。本服务未必在所有国家/地区和以各种语言提供。
            </p>
            <p>3.<strong>健康管理系统，</strong>健康管理系统是为您自动诊断设备健康状态的服务。您可以通过健康管理系统发现和检查设备各个部件当前的工作状态，以及查看遇到问题时的应对方法。但您理解，由于技术限制及其他各类原因，起迪并不能保证前述相关功能能够完全准确的检测出所有问题。
            </p>
            <p>4.<strong>打印结果检测</strong>，打印结果检测为您自动检测实际打印过程中发生的问题，包括首层扫描功能、失败（炒面）检测功能、自动跳过失败零件的功能。使用这些服务可以在打印发生问题时给出检查提示、在发生严重问题时自动停止打印、以及在打印过程中精确的跳过个别打印出问题的零件。但您理解，由于技术限制及其他各类原因，起迪并不能保证前述相关功能能够完全准确的检测，特殊情况下可能存在误检的风险。
            </p>
            <h1><strong>九、第三方软件声明</strong></h1>
            <p>您明确了解并同意，起迪产品支持执行通用的G-code文件，但并不保证第三方软件生成的G-code在任何期间的可用性，同时也不会对在起迪设备上运行第三方软件生成的G-code时所产生的产品损伤承担责任。
            </p>
            <h1><strong>十、本条款之变更</strong></h1>
            <p>我们可能会不时更新本条款。我们会根据合适的情况给您提供相应的通知。例如，我们可能会在相关服务或我们的网站中显示的相关通知，或向您发送电子邮件或设备通知。您可以在页面顶部找到条款最后更新的日期。也请您定期访问我们的网站，查看条款的任何更改。如果您在本条款更新生效后继续访问或使用本服务或产品，即表示您接受新条款。如果您不同意新的条款，请您务必停止访问或使用相关服务或产品。
            </p>
            <h1><strong>十一、终止和持续有效性</strong></h1>
            <p>（一）
                本条款自您安装软件的首日生效。如果您未能遵守本条款中的任一条款或条件，您的账号可能被停用，本产品也可能被限制或停止使用。您的账号被停用后，您必须立即停止使用本产品，并删除所有已经复制和/或安装在您的起迪设备或计算机上的软件及相关材料。
            </p>
            <p>（二） 本条款终止后，第六、十二和十三继续有效。</p>
            <h1><strong>十二、免责条款</strong></h1>
            <p>（一）
                您确认本产品是“按原样”提供，不存在任何形式的明示或暗示担保，并且在适用法律允许的最大范围内，起迪、其许可方/附属公司或版权持有者均不提供任何明示或暗示的陈述或保证，包括但不限于有关适销性、满意质量、适用于特定目的、准确性、保密权以及不侵犯第三方权利的保证。起迪或任何其他方均不保证产品中所含的功能将满足您的要求，也不保证产品的运行不会中断或出错。选择本产品来达到预期结果，以及安装、使用本产品并获取结果所带来的所有责任和风险由您承担。
            </p>
            <p>（二）您进一步确认，设备打印、校准、操控过程中，不允许将身体部位或物品伸入设备内部，以避免潜在的烫伤、夹伤风险，因此导致的人身损伤或设备损伤的所有责任和风险由您承担。
            </p>
            <h1><strong>十三、责任限制</strong></h1>
            <p>（一） 对于因滥用、错误使用或未经授权修改所引起的产品使用问题，起迪不承担任何责任。</p>
            <p>（二）
                在适用法律未明令禁止的程度下，对于因使用或无法使用本产品而引起的任何利润、收入、销售损失、数据丢失或采购替代商品或服务的成本、财产损害、人身伤害、业务中断、商业信息损失，或者任何特殊的、直接的、间接的、附带的、经济性、惩罚性、特殊或从属损害，无论是基于何种责任理论（合同、侵权、过失或其他），起迪及其员工、许可方或附属公司都不承担赔偿责任，即使其已被告知存在此种损害的可能性也是如此。某些司法管辖区不允许对人身伤害、附带或从属损害等进行责任限制，则此限制可能不适用于您。
            </p>
            <p>（三） 起迪对您的所有损失承担的总责任赔付限额（除了因起迪过失导致人身伤亡的情况，需遵循适用法律规定）不超过您购买起迪产品所支付的价款。</p>
            <p>（四）
                部分国家/地区的法律不允许条款中排除或限制某些保证、担保或责任。若这些法律适用于您，则本文所述的排除或限制条款的全部或部分可能不适用于您，您可享有额外的权利。本条款中的任何内容均不影响您作为消费者应该享有的法定权利，也不影响您无法通过合同同意变更或放弃的权利。
            </p>
            <h1><strong>十四、技术支持</strong></h1>
            <p>除起迪保修政策（您可在以下网站上查阅售后政策的详细信息：<a
                    href="#/policies/warranty">https://www.qidi3d.cn/zh/policies/warranty</a>）中明确规定外，起迪没有义务为您提供法律规定以外的任何针对本条款中所述产品的技术支持服务。起迪或起迪授权代表给予的口头或书面的信息或意见均不构成任何担保。
            </p>
            <h1><strong>十五、出口管制</strong></h1>
            <p>除非得到适用法律以及获取起迪产品所在的司法管辖区内的相关法律的授权，您不得使用或者以其他方式出口或转出口起迪产品。</p>
            <h1><strong>十六、如何联系起迪</strong></h1>
            <p>如果您有任何疑问、意见或建议，请通过在线客服与我们联系，或者向我们的电子邮箱<a
                    href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>发送电子邮件。</p>
            <h1><strong>十七、争议解决和所依据法律</strong></h1>
            <p>本条款的验证、解释、修改、履行和争议解决受中华人民共和国法律的管辖。如果发生任何有关本条款的内容或履行的争议，则应通过友好协商解决。如果无法通过协商解决，起迪和您均可以将争议提交中国国际经济贸易仲裁委员会（CIETAC）仲裁，按照申请仲裁时CIETAC的仲裁规则进行。仲裁庭应由三（3）名仲裁员组成。起迪和您均有权指定一名仲裁员，第三名仲裁员应由CIETAC指定。仲裁语言为英语，在中国上海进行。所有仲裁员都必须精通英语。仲裁裁决为终局裁决，对起迪和您均具有约束力。
            </p>
            <h1><strong>十八、完整条款</strong></h1>
            <p>本条款与用户协议构成了您与起迪之间达成的管控您的产品使用的完整协议，并将取代之前您与起迪达成的关于产品使用的任何协议。当您使用或购买开源软件、第三方内容或起迪的其他服务时，可能还需遵守其他适用的条款和条件。
            </p>
            <p>&nbsp;</p>
        </div>
</body>
</html>
      `
  },
  methods: {
    getPrivacy() {
      let params = {
        type: "1",
        lang: 'zh'
      }
      articleDetail(params).then(res => {
        console.log(res)
        if (res.status === 0) {
          this.articleContent = res.data.content;
          console.log('this.articleContent', this.articleContent);
          //this.$notify.success({
          //   title: this.$t('h.common.tip'),
          //   message: "获取用户协议成功",
          //   type: "success"
          // });
        } else {
          //this.$notify.error({
          //   title: this.$t('h.common.tip'),
          //   message: "获取用户协议错误",
          //   type: "error"
          // });
        }
      })
    }
  }
}
</script>


<style scoped lang="scss">
@import '@/assets/scss/common.scss';

>>> .article-css{
  @include background_color('background_color');
  @include font_color('text-color');
}

</style>



// WEBPACK FOOTER //
// src/views/policies/terms.vue